import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { map, first } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { LaserficheTrustee } from '../_models/laserfiche-trustee.model';
import { EnvironmentService } from './environment.service';
import { GroupUser } from '../_models/group-user.model';
import { ResponseObject } from '../_models/response-object.model';
import { AuthenticationService } from './authentication.service';
import { User } from '../_models/user.model';

@Injectable()
export class LaserficheAdminService {

  adminGroupName = 'CFM_PORTAL_ADMINISTRADORES';
  consultaGroupName = 'CFM_PORTAL_CONSULTA';
  subsidioGroupName = 'CFM_PORTAL_SUBSIDIO';

  adminUsersSubject: Subject<LaserficheTrustee[]> = new Subject<LaserficheTrustee[]>();
  subsidioUsersSubject: Subject<LaserficheTrustee[]> = new Subject<LaserficheTrustee[]>();
  consultaUsersSubject: Subject<LaserficheTrustee[]> = new Subject<LaserficheTrustee[]>();

  constructor(private http: HttpClient,
              private environmentService: EnvironmentService,
              private authService: AuthenticationService) {

  }

  private getGroupName(role: string): string {
    let groupName = '';
    switch (role) {
      case 'ADMIN':
        groupName = this.environmentService.adminGroupName;
        break;
      case 'CONSULTA':
        groupName = this.environmentService.consultaGroupName;
        break;
      case 'SUBSIDIO':
        groupName = this.environmentService.subsidioGroupName;
        break;
    }
    return groupName;
  }

  getUsersFromGroup(role: string) {
    const groupName = this.getGroupName(role);
    const user: User = this.authService.currentUserValue;
    let options = {};
    if (user && user.authToken) {
      options = {
        headers: new HttpHeaders()
        .append(
          'Authorization',
          `Bearer ${user.authToken}`
        ),
        params: new HttpParams()
        .set(
          'groupName',
          groupName
        ),
      };
    } else {
      options = {};
    }
    // console.log(options);
    return this.http.get(`${this.environmentService.apiUrl}/UserAdmin/ListUsers`, options)
    .pipe(
      map((response: ResponseObject) => {
        return response.success ? response.responseObject as GroupUser[] : [];
      })
    );
  }

  getAdminUsers() {
    return this.getUsersFromGroup('ADMIN');
  }

  getSubsidioUsers() {
    return this.getUsersFromGroup('SUBSIDIO');
  }

  getConsultaUsers() {
    return this.getUsersFromGroup('CONSULTA');
  }

  addUserToGroup(account: string, group: string, initiator: string) {
    const user: User = this.authService.currentUserValue;
    let options = {};
    if (user && user.authToken) {
      options = {
        headers: new HttpHeaders()
        .append(
          'Authorization',
          `Bearer ${user.authToken}`
        ),
        params: new HttpParams()
        .set('userAccount', account)
        .set('groupName', group)
        .set('_initiator', initiator),
      };
    } else {
      options = {};
    }
    // console.log(options);
    // return this.http.post(`${this.environmentService.apiUrl}/UserAdmin`, trusteeData)
    return this.http.put(`${this.environmentService.apiUrl}/UserAdmin/AddUser`, { }, options)
    .pipe(
      map((response: ResponseObject) => {
        // console.log(response);
        return response;
      })
    );
  }

  removeUserFromGroup(account: string, group: string, initiator: string) {
    const user: User = this.authService.currentUserValue;
    let options = {};
    if (user && user.authToken) {
      options = {
        headers: new HttpHeaders()
        .append(
          'Authorization',
          `Bearer ${user.authToken}`
        ),
        params: new HttpParams()
        .set('userAccount', account)
        .set('groupName', group)
        .set('_initiator', initiator),
      };
    } else {
      options = {};
    }
    // console.log(options);
    return this.http.delete(`${this.environmentService.apiUrl}/UserAdmin/RemoveUser`, options)
    .pipe(
      map((response: ResponseObject) => {
        // console.log(response);
        return response;
      })
    );
  }
}
